import { ETicketFilter } from '@constants';
import { Badge, Flex } from 'antd';

import { useMyTicketsList } from '@/store';
import { formatBadgeCount } from '@/utils';

export const PendingDoubtsBadge = () => {
  const { isLoading, pagination } = useMyTicketsList(ETicketFilter.OPEN);

  if (isLoading) return null;

  const displayCount = formatBadgeCount(pagination?.totalDocs);
  if (!displayCount) return null;

  return (
    <Flex align="center" justify="center">
      <Badge count={displayCount} />
    </Flex>
  );
};
